// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_hp","advertCardList_max6":"c-a_hq"};